import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AdminMerits from "@/pages/admin/MeritsManagement";
import AdminLettering from "@/pages/admin/LetteringManagement";
import AdminThespian from "@/pages/admin/ThespianManagement";

const TABS = ["merits", "lettering", "thespian"];

export default function Programs() {
  const [searchParams] = useSearchParams();
  const initial = searchParams.get("tab");
  const [tab, setTab] = useState(TABS.includes(initial) ? initial : "merits");
  return (
    <div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4" data-testid="programs-tabs">
          <TabsTrigger value="merits" data-testid="programs-tab-merits">Merit System</TabsTrigger>
          <TabsTrigger value="lettering" data-testid="programs-tab-lettering">Letter Points</TabsTrigger>
          <TabsTrigger value="thespian" data-testid="programs-tab-thespian">Thespian Points</TabsTrigger>
        </TabsList>
        <TabsContent value="merits" data-testid="programs-panel-merits"><AdminMerits /></TabsContent>
        <TabsContent value="lettering" data-testid="programs-panel-lettering"><AdminLettering /></TabsContent>
        <TabsContent value="thespian" data-testid="programs-panel-thespian"><AdminThespian /></TabsContent>
      </Tabs>
    </div>
  );
}
